import { render, staticRenderFns } from "./AxisY1Title.vue?vue&type=template&id=e47f7efc&scoped=true&"
import script from "./AxisY1Title.vue?vue&type=script&lang=ts&"
export * from "./AxisY1Title.vue?vue&type=script&lang=ts&"
import style0 from "./AxisY1Title.vue?vue&type=style&index=0&id=e47f7efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47f7efc",
  null
  
)

export default component.exports